import { Logo } from "./Logo";
import { scrollToId } from "@/lib/scroll";
import { getCompanies } from "@/data/content";
import { UI } from "@/i18n/copy";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { lang } = useLang();
  const t = UI[lang].footer;
  const companies = getCompanies(lang);

  return (
    <footer data-testid="site-footer" className="bg-black text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo dark />
            <p className="mt-6 max-w-sm text-base leading-relaxed text-white/60">{t.tagline}</p>
            <p className="mt-6 font-mono-label text-[11px] uppercase tracking-[0.25em] text-white/40">
              {t.location}
            </p>
          </div>

          <div>
            <h4 className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-white/40">
              {t.companiesHeading}
            </h4>
            <ul className="mt-6 space-y-3">
              {companies.map((c) => (
                <li key={c.id}>
                  <button
                    data-testid={`footer-link-${c.id}`}
                    onClick={() => scrollToId(`company-${c.id}`)}
                    className="group flex items-center gap-2.5 text-sm font-semibold text-white/70 transition-colors hover:text-white"
                  >
                    <span className="h-1.5 w-1.5 rotate-45" style={{ backgroundColor: c.color }} />
                    {c.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono-label text-[11px] uppercase tracking-[0.3em] text-white/40">
              {t.groupHeading}
            </h4>
            <ul className="mt-6 space-y-3">
              {[
                { label: t.about, id: "about" },
                { label: t.ourCompanies, id: "companies" },
                { label: t.contact, id: "contact" },
              ].map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm font-semibold text-white/70 transition-colors hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-white/45">{t.rights}</p>
          <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-white/30">
            {t.mark}
          </p>
        </div>
      </div>
    </footer>
  );
};
